/*
 * View for the user menu
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/header/userMenu/template/userMenuTemplate.html",
], function (Marionette, Messenger, UserMenuTemplate) {
  "use strict";

  let UserMenuView = {};

  UserMenuView.userMenuView = Marionette.ItemView.extend({
    template: UserMenuTemplate,
    events: {
      "click #help": function () {
        this._initHelpIfNeeded();
        this.$el.find("#help").toggleClass("btn-astute active");
        this.$el.find(".popover").toggle();
      },
      //use events instead of triggers for these clicks so that the dropdown can close automatically
      "click #apiAdmin": function (e) {
        this.trigger("api:admin");
        e.preventDefault();
      },
      "click #categoryAdmin": function (e) {
        this.trigger("category:admin");
        e.preventDefault();
      },
      "click #campaignAdmin": function (e) {
        this.trigger("campaign:admin");
        e.preventDefault();
      },
      "click #variableAdmin": function (e) {
        this.trigger("variable:admin");
        e.preventDefault();
      },
      "click #accountAdmin": function (e) {
        this.trigger("account:admin");
        e.preventDefault();
      },
      "click #attributesAdmin": function (e) {
        this.trigger("attribute:admin");
        e.preventDefault();
      },
      "click #siteMapsAdmin": function (e) {
        this.trigger("siteMap:admin");
        e.preventDefault();
      },
      "click #tableOfContentsAdmin": function (e) {
        this.trigger("tableOfContents:admin");
        e.preventDefault();
      },
      "click #topicListingAdmin": function (e) {
        this.trigger("topicListing:admin");
        e.preventDefault();
      },
    },
    modelEvents: {
      "change:userName": "render",
    },
    onRender: function () {
      this.$el.i18n();
      //show tooltip on the bottom
      this.$el.find('a[data-toggle="tooltip"], button[data-toggle="tooltip"]').tooltip({
        delay: { show: 333, hide: 0 },
        container: "body",
        placement: "bottom",
      });
    },
    triggers: {
      "click #logout": "logout",
      "click #preferences": "config",
    },
    templateHelpers: {
      isShowSiteMaps: function () {
        return this.admin && this._thisObject.kb.get("siteMapAccess");
      },
    },
    activateAdminButton: function () {
      this.$el.find("#config").addClass("active btn-astute");
    },
    deactivateAdminButton: function () {
      this.$el.find("#config").removeClass("active btn-astute");
    },
    hideDropdown: function () {
      this.$el.find("#userDropdown").parent().removeClass("open");
    },
    _initHelpIfNeeded: function () {
      if (!this._helpUrl) {
        //set the url of the help UI.
        let user = Messenger.reqres.request("user");
        this._helpUrl = user.get("helpUrl");
        this.$el.find("iframe").attr("src", this._helpUrl);
      }
    },
  });

  return UserMenuView;
});
